import styled from "@emotion/styled";

export const ObjectDetailBodyWrapper = styled.div`
  font-size: 1rem;
  flex: 1;
  overflow-y: auto;
`;
